import { useCallback } from 'react'

export const usePlaySound = () => {
  const playSound = useCallback(async (soundUrl: string) => {
    try {
      const audio = new Audio(soundUrl)
      await audio.play()
    } catch (err) {
      console.error('Error playing sound:', err)
    }
  }, [])

  return playSound
}
